import { generateHash } from "../../utils/uid"

const DEFAULT_DOC_ID_LENGTH = 29
export const newDocId = () => generateHash(DEFAULT_DOC_ID_LENGTH)
